export enum DisplayMode {
  Dropdown = 'Dropdown',
  Menu = 'Menu',
}
